// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePptFilledSvg from "@fishx/icons-svg/es/asn/FilePptFilled";
import FishxIcon from '../components/FishxIcon';

var FilePptFilled = function FilePptFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePptFilledSvg
  }));
};

FilePptFilled.displayName = 'FilePptFilled';
export default React.forwardRef(FilePptFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePptFilled.js
// module id = 2736
// module chunks = 0